import { useState, useCallback } from 'react';
import apiService from '../../../services/ApiService';

export const useActivityManagement = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');
  const pageSize = 10;

  const loadActivities = useCallback(async (page = currentPage, search = searchTerm) => {
    try {
      setLoading(true);
      const params = {
        page: page - 1,
        size: pageSize,
        search: search || undefined,
      };
      
      const response = await apiService.getAdminActivity(params);
      setActivities(response.content || []);
      setTotalPages(response.totalPages || 1);
      setTotalItems(response.totalElements || 0);
    } catch (error) {
      console.error('Failed to load activities:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchTerm]);

  const getFilteredActivities = useCallback(() => {
    return activities.filter((activity) => {
      const matchesType = typeFilter === 'all' || activity.type === typeFilter;
      return matchesType;
    });
  }, [activities, typeFilter]);

  const handleSearch = useCallback((search) => {
    setSearchTerm(search);
    setCurrentPage(1);
    loadActivities(1, search);
  }, [loadActivities]);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
    loadActivities(page, searchTerm);
  }, [loadActivities, searchTerm]);

  return {
    activities,
    loading,
    currentPage,
    totalPages,
    totalItems,
    searchTerm,
    typeFilter,
    setSearchTerm,
    setTypeFilter,
    loadActivities,
    getFilteredActivities,
    handleSearch,
    handlePageChange,
  };
};
